import { StackStatus } from "../../../services/backend_gateway/__generated__/backend_gateway-types";
import { AuthenticationComponent } from "./component";

export const AuthenticationContainer = (props: {
  deploymentId: string;
  navigateToHelp: (stepId: string) => void;
  authenticationStackStatus: StackStatus | null;
}) => {
  const { deploymentId, authenticationStackStatus } = props;

  return (
    <AuthenticationComponent
      loading={false}
      deploymentId={deploymentId}
      authenticationStackParamsJson={
        authenticationStackStatus?.parametersJSON || null
      }
      authenticationStackStatus={authenticationStackStatus?.status || null}
    />
  );
};
